import type { CohortAnnouncement } from '@efdigital/ll-xceed-v2/data/builders/xceed/messages';
import { markdownPlainPreview } from '@efdigital/ll-xceed-v2/utils/coaching/announcements';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface AnnouncementBannerSignature {
  Args: {
    announcement: CohortAnnouncement;
    unreadCount: number;
  };
  Element: HTMLDivElement;
}

const AnnouncementBanner: TOC<AnnouncementBannerSignature> = <template>
  <div class="mb-4" ...attributes>
    <LinkTo
      @route="coaching.coachee.cohort.announcements"
      class="card border border-primary border-2 shadow-sm rounded-4 w-100 text-start text-decoration-none"
      aria-label="Open announcement: {{@announcement.title}}"
      data-test-announcement-banner
    >
      <div class="card-body d-flex align-items-center gap-3 py-3 px-3 px-sm-4">
        <span
          class="rounded-circle text-bg-primary d-flex align-items-center justify-content-center flex-shrink-0 position-relative p-3"
        >
          <iconify-icon
            inline
            icon="ph:megaphone"
            class="fs-5"
            aria-hidden="true"
          />
          {{#if @unreadCount}}
            <span
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill text-bg-warning border border-2 border-white"
              aria-label="{{@unreadCount}} unread"
            >{{@unreadCount}}</span>
          {{/if}}
        </span>
        <span class="flex-grow-1 min-w-0 ms-2">
          <span class="d-block fw-bold text-body">{{@announcement.title}}</span>
          <span class="d-block small text-body-secondary">
            {{markdownPlainPreview @announcement.markdown}}
          </span>
        </span>
        <span
          class="text-primary fw-semibold d-none d-sm-inline-flex align-items-center gap-1 flex-shrink-0"
        >
          Open
          <iconify-icon inline icon="ph:arrow-right" aria-hidden="true" />
        </span>
      </div>
    </LinkTo>
  </div>
</template>;

export default AnnouncementBanner;
